<template>
  <div class='sub-content'>
    <div class='grid-wrap'>
      <dx-data-grid ref='refInventoryGrid'
        :data-source='inventoryReceiptInfo'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        @focused-row-changed="onSelectionChanged"
        :auto-navigate-to-focused-row="false"
        key-expr="seqId"
        @toolbar-preparing='onToolbarPreparing'
        @cell-prepared='onCellPreparedOutput'
        @row-updated='onRowUpdated' @row-removed="onRowRemoved"
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          :file-name="exportTitle"
        />
        <DxEditing
          :allow-deleting="isEditable"
          :allow-updating="isEditable"
          :allow-adding="false"
          :use-icons="true"
          mode='row'
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumnFixing :enabled="true"/>
        <DxColumn
          :allowEditing='false'
          caption="차종"
          data-field="차종"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :fixed="false"
          caption="처리일"
          data-field="발생일"
          dataType='date'
          format='yyyy-MM-dd'>
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :fixed="false"
          caption="처리일시"
          data-field="발생일자"
          dataType='datetime'
          format='yyyy-MM-dd HH:mm:ss'>
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :fixed="false"
          caption="품번"
          data-field="품번"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :fixed="false"
          caption="품명"
          data-field="품명"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="자재유형"
          data-field="자재유형"
          :visible='true'
        >
          <DxLookup
            :data-source="meterialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="구분"
          data-field="입출고구분"
          :visible='true'
          sort-order='desc'
        >
          <DxLookup
            :data-source="receiptTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="수량"
          data-field="수량"
          :visible='true'
          format='#,##0'
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="구매단가"
          data-field="가격"
          :visible='true'
          format='#,##0'
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="구매금액"
          data-field="구매금액"
          :calculate-cell-value="calcAmount"
          :visible='true'
          format='#,##0'
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="파레트번호"
          data-field="입고키"
          format='#,##0'
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="거래처"
          data-field="거래처명"
          :visible='true'
        >
        </DxColumn>
          <DxColumn
          :allowEditing='false'
          caption="LOT_NO"
          data-field="lotNo"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          width="90"
          :buttons="editSubButtons"
          type="buttons"
        />
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            column="발생일자"
            display-format="{0} (건)"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="수량"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="구매금액"
            display-format="{0}"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxColumnFixing, DxTotalItem, DxLookup, DxEditing,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel, DxExport } from 'devextreme-vue/data-grid'

export default {
  name: 'inventory-receipt',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      inventoryReceiptInfo: null,
      selectedRow: null,
      thisYear: null,
      yearArray: [],
      thisMonth: null,
      monthArray: [],
      selectBoxVendorOptions: [],
      selectedVendor: 'ALL',
      exportTitle: null,
      receiptTypeLookup: null,
      // isEditable: true,
      editSubButtons: ['edit', 'delete'],
      meterialTypeLookup: null
    }
  },
  props: {
    materialType: {
      type: String,
      default: null
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxExport,
    DxEditing,
    DxLookup
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.$store.commit('deleteInoutList')
    this.thisYear = AppLib.getThisYear()
    for (let i = this.thisYear; i >= 2021; i--) {
      this.yearArray.push({ 'year': i })
    }
    this.thisMonth = AppLib.getThisMonth()
    for (let i = 1; i <= 12; i++) {
      if (i > 0 && i < 10) {
        this.monthArray.push({ 'name': i + '월', value: '0' + i })
      } else {
        this.monthArray.push({ 'name': i + '월', value: '' + i })
      }
    }
    this.selectBoxVendorOptions = this.$Q.extend(true, [], this.$store.getters.getPartnersInfo)
    this.selectBoxVendorOptions.unshift({ 거래처명: 'ALL', 거래처코드: 'ALL' })
    console.log(this.selectBoxVendorOptions)
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.receiptTypeLookup = ConstDef.PURCHASE_INOUT_CODE
    this.refreshInventoryList()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {
    this.$store.commit('deleteInoutList')
  },
  methods: {
    isEditable () {
      let baseDate = `${this.thisYear}-${this.thisMonth}`
      let result = false
      if (!AppLib.isInOutCRUDable(baseDate)) {
        result = false
      } else {
        result = true
      }
      return result
    },
    calcAmount (row) {
      if (row.입출고구분 === ConstDef.자재입고) {
        return row.수량 * row.가격
      }
      return null
    },
    onCellPreparedOutput (e) {
      if (e.rowType === 'data' && e.column.dataField === '입출고구분') {
        if (e.data.입출고구분 === this.$_.findWhere(ConstDef.PURCHASE_INOUT_CODE, { 코드명: '자재입고' }).코드) { // 재공재고
          this.$Q(e.cellElement).css('color', 'blue')
        } else if (e.data.입출고구분 === this.$_.findWhere(ConstDef.PURCHASE_INOUT_CODE, { 코드명: '사급출고' }).코드) { // 재공재고
          this.$Q(e.cellElement).css('color', 'red')
        }
      }
    },
    onRowUpdated (row) {
      console.log(row)
      this.$_sp.runUpdateSqlProc('창고수불', ['seqId'], null, [{ seqId: row.data.seqId, 수량: row.data.수량, 발생일자: row.data.발생일자 }])
        .then((data) => {
          this.$snotify.info('수정 되었습니다.')
        })
    },
    onRowRemoved (row) {
      this.$_sp.runDeleteSqlProc('창고수불', [{ seqId: row.data.seqId }])
        .then((data) => {
          this.$snotify.info('삭제 되었습니다.')
        })
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>연도 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.yearArray,
            valueExpr: 'year',
            displayExpr: 'year',
            value: this.thisYear,
            onValueChanged: (args) => {
              this.$store.commit('deleteInoutList')
              this.thisYear = args.value
              this.refreshInventoryList()
            }
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>월 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.monthArray,
            valueExpr: 'value',
            displayExpr: 'name',
            value: this.thisMonth,
            onValueChanged: (args) => {
              this.$store.commit('deleteInoutList')
              this.thisMonth = args.value
              this.refreshInventoryList()
            }
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>거래처 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 100,
            items: this.selectBoxVendorOptions,
            valueExpr: '거래처코드',
            displayExpr: '거래처명',
            value: this.selectedVendor,
            onValueChanged: (args) => {
              this.selectedVendor = args.value
              this.refreshInventoryList()
            }
          }
        }
      )
    },
    refreshInventoryList () {
      this.exportTitle = `${this.thisYear}-${this.thisMonth}-자재입출고현황`
      this.inventoryReceiptInfo = this.$store.getters.getPurchaseInfoList(this.selectedVendor)
      if (this.inventoryReceiptInfo === null) {
        this.isLoading = true
        let endDate = `${this.thisYear}-${this.thisMonth}-${AppLib.getMonthLastDay(this.thisYear, this.thisMonth)}`
        endDate = AppLib.calcDateFromFormat(endDate, 1)
        let param = {
          startDate: `${this.thisYear}-${this.thisMonth}-01`,
          endDate: `${endDate}`,
          품목유형: ConstDef.구매품,
          자재유형: null,
          거래처코드: this.selectedVendor,
          마감: 0
        }
        this.$_sp.runNoEncodeFindProc('spFindAllInventoryReceiptByDateAndGoodsType', param)
          .then((data) => {
            this.isLoading = false
            if (this.materialType === ConstDef.외주품) { // 구매관리 외주품입고현황 에서 보여줄 내용 -> 외주,외주직납
              this.inventoryReceiptInfo = this.$_sp.MakeModel(data).filter(item => item.자재유형 === ConstDef.외주품 || item.자재유형 === ConstDef.외주직납품)
            } else {
              this.inventoryReceiptInfo = this.$_sp.MakeModel(data)
            }
            console.log(this.inventoryReceiptInfo)
            this.$store.commit('savePurchaseInoutList', { data: this.inventoryReceiptInfo, option: param })
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(`에러코드 : ${error.response.status}`)
            }
          })
      }
    }
  }
}
</script>

<style lang="scss">

</style>
